export default (node) => {
  const checkIfInView = (element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const muteVideoIfOutOfView = () => {
    let videoMobile = node.querySelector('[data-mobile-video]'); // Select mobile video
    let videoDesktop = node.querySelector('[data-desktop-video]'); // Select desktop video

    if (videoMobile && !checkIfInView(videoMobile)) {
      if (!videoMobile.muted) {
        videoMobile.muted = true;
      }
    }
    if (videoDesktop && !checkIfInView(videoDesktop)) {
      if (!videoDesktop.muted) {
        videoDesktop.muted = true;
      }
    }
  };

  const init = () => {
    node.addEventListener('click', (e) => {
      if (node.dataset.openModal) {
        e.preventDefault();
        const event = new CustomEvent('modal-video:open', {
          detail: node,
        });
        document.dispatchEvent(event);
      } else {
        // Match the md breakpoint (800px) used to toggle the mobile/desktop videos
        const isMobile = window.matchMedia('(max-width: 799px)').matches;

        let video;
        if (isMobile) {
          video = node.querySelector('[data-mobile-video]'); // Select mobile video
        } else {
          video = node.querySelector('[data-desktop-video]'); // Select desktop video
        }

        if (video) {
          video.play(); // Play the selected video
          video.muted = false; // Unmute the video
          hidePlayButton(node);
          // showVideoControls(video);
        } else {
          console.error('Video element not found.');
        }
      }
    });

    window.addEventListener('scroll', muteVideoIfOutOfView);
  };

  const hidePlayButton = (node) => {
    const playButtonContainer = node.querySelector(
      '[data-play-button-container]'
    );
    if (playButtonContainer) {
      playButtonContainer.remove();
    }
  };

  const showVideoControls = (video) => {
    video.controls = true;
  };

  /**
   * Init
   */
  init();
};
